<p-tabView styleClass="p-0">
  <p-tabPanel header="{{'PROPERTY.SELECT_RESIDENT' | translate }}">
    <app-select-assign-renter [apartment]="apartment"/>
  </p-tabPanel>
  <p-tabPanel header="{{'PROPERTY.CREATE_RESIDENT' | translate }}">
    <app-create-assign-renter [apartment]="apartment"/>
  </p-tabPanel>
</p-tabView>
